let colors = {
  RED:          "#e0002b",
  PINK:         "#fd8e8e",
  HOT_PINK:     "#eb4360",
  ORANGE:       "#ff8309",
  GOLD:         "#ffb800",
  GREEN:        "#7ac724",
  TEAL:         "#00afc2",
  TURQUOISE:    "#2aceba",
  BLUE:         "#0078bc",
  LIGHT_BLUE:   "#aad6ed",
  HOT_BLUE:     "#009cff",
  SCREEN_BLUE:  "#f0f6f9",
  BROWN:        "#74603c",
  LIGHT_BROWN:  "#ceba95",
  NAVY:         "#304561",
  PURPLE:       "#9547a1",
  LIGHT_PURPLE: "#c5a7ca",
  GRAY:         "#7e8890",
  LIGHT_GRAY:   "#e8e8e8",
  SCREEN_GRAY:  "#f8f8f8"
};

module.exports = colors;